
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { VCard, VCardTitle, VSpacer } from 'vuetify/lib';
import FormDialog from "@/components/dialogs/FormDialog.vue";
import AdresForm from "@/components/forms/AdresForm.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import { AdresEntity } from "@/entity/AdresEntity";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import { AdresTuruLabel } from "@/enum/AdresTuru";
import { adresAlanAdi, adresIlceSorunu, ILCE_DUZELTME_ONERISI } from "@/helpers/AdresIlceDenetimi";
import { yeniYetkiModu } from "@/plugins/yetkiKontrol";

@Component({
  components: { FormDialog, AdresForm, DeleteDialog, VCard, VCardTitle, VSpacer }
})
export default class AdresList extends Mixins(SimpleInputMixin) {
  @Prop({}) items!: Array<AdresEntity>;
  @Prop({}) action!: string;
  @Prop({}) successOnValidate!: any;
  @Prop() yabanciUyruklu!: string | boolean;
  @Prop() height!: string;
  @Prop() footerProps!: any;
  @Prop() rules!: any;
  @Prop({ default: false }) hideRightsCheck!: boolean;

  AdresTuruLabel = AdresTuruLabel;
  adresAlanAdi = adresAlanAdi;
  localValue!: Array<AdresEntity>;
  selectedAddressId: any = null;

  headers = [
    { text: "Adres", align: "start", sortable: false, value: "adres", class: 'my-header-style' },
    { text: "İşlemler", align: "end", sortable: false, value: "actions", class: 'header-islemler-style' },
  ]


  mounted() {
    if (!this.value) {
      this.localValue = [];
    }
    const savedSelectedItemId = localStorage.getItem("selectedAddressItemId");
    if (savedSelectedItemId) {
      this.selectedAddressId = savedSelectedItemId;
      const selected = this.localValue.find((item:any) => item.id === savedSelectedItemId);
      if (selected) {
        this.$emit('address-selected', selected);
      }
    }
  }

  get isYabanciUyruklu() {
    return this.yabanciUyruklu || this.yabanciUyruklu == '';
  }

  ilceSorunu(item: AdresEntity): string | null {
    return adresIlceSorunu(item);
  }

  /** Aktarımdan ilçesiz gelen adres ekranda sessizce eksik kalmasın diye (DEV-2726). */
  ilceUyarisi(item: AdresEntity): string {
    const sorun = adresIlceSorunu(item) || '';
    return sorun.charAt(0).toLocaleUpperCase('tr') + sorun.slice(1) + '. ' + ILCE_DUZELTME_ONERISI;
  }

  @Watch("items")
  onItemsChange() {
    this.localValue = this.items;
  }

  onAdd(item: AdresEntity) {
    if (this.action) {
      this.load();
    } else {
      this.localValue.push(item);
      this.input();
    }
  }

  onUpdate(item: AdresEntity, index: number) {
    // Adres nesnesini düzenleme işlemi için hazırlama
    const processedItem = {...item};
    
    // İlişki nesnesi yerine adı tutulur. Formda seçilen id esastır: nesne düzenleme öncesine
    // aitse (id'si tutmuyorsa) ya da sunucu ilişkiyi eski id'yle null döndürdüyse atılır;
    // önceden eski ilçe id'si geri yazılıp kaydedilen düzeltme bozuluyordu (DEV-2726).
    const item_: any = processedItem;
    if (item_.sehir && typeof item_.sehir === 'object') {
      item_.sehir_id = item_.sehir_id || item_.sehir.id;
      item_.sehir = !item_.sehir.id || item_.sehir.id == item_.sehir_id ? (item_.sehir.isim || '') : undefined;
    } else if (item_.sehir === null && item_.sehir_id) {
      item_.sehir = undefined;
    }

    if (item_.ilce && typeof item_.ilce === 'object') {
      item_.ilce_id = item_.ilce_id || item_.ilce.id;
      item_.ilce = !item_.ilce.id || item_.ilce.id == item_.ilce_id ? (item_.ilce.isim || '') : undefined;
    } else if (item_.ilce === null && item_.ilce_id) {
      item_.ilce = undefined;
    }
    
    // Dizi yerinde güncellenir (ekleme/silme gibi): üstteki formlar (KisiForm/KurumForm →
    // BorcluForm) aynı diziyi paylaşır ve listeden input almaz. Yeni dizi atanınca düzeltme
    // yalnız listede kalıyor, BorcluForm eski adresi kaydedip seçilen ilçeyi siliyordu (DEV-2726).
    this.localValue.splice(index, 1, processedItem);
    this.input();
    this.load()
  }

  onDelete(index: number) {
    this.localValue.splice(index, 1);
    this.input();
  }

  load() {
    this.$emit("load");
  }

  isAuthorized(keySuffix: string) {
    if (this.hideRightsCheck) {
      return true;
    }

    let ap = [...this.$store.state.activeProcesses].reverse();


    if (!ap || ap.length === 0) {
      return false;
    }

    let authKey = null;

    if (keySuffix[0] !== '-')
      keySuffix = '-' + keySuffix;

    if (ap[0].key === "takip-ac" || ap[0].key === "takip-duzenle")
      // DEV-2684: yeni modda sunucunun işlem bazlı anahtarı (takip-adres-ekle/-duzenle/-sil).
      // Eski modda karar Spatie izin adından verilir ve `takip-adres*` diye bir izin yoktur;
      // bu yüzden eski modda bugünkü `takip-ac` izni korunur. Mod tespiti tek kaynaktan.
      authKey = yeniYetkiModu(this.$store.state.user) ? "takip-adres" + keySuffix : "takip-ac";
    else if (ap[0].key === "borclu-detay")
      authKey = "borclu-adres-bilgisi" + keySuffix;
    else if (ap[0].key === "alacakli-detay")
      authKey = "muvekkil-adres-bilgisi" + keySuffix;
    else if (ap[0].key === "buro-detay")
      authKey = "buro-adres-bilgisi" + keySuffix;
    else if (ap[0].key === "personel-detay")
      authKey = "calisan-adres-bilgisi" + keySuffix;
    else if (ap[0].key === "muvekkil-detay" || ap[0].key === "vekalet-detay")
      authKey = "muvekkil-adres-bilgisi" + keySuffix;
    else if (ap[0].key === "avukat-detay")
      authKey = "avukat-adres-bilgisi" + keySuffix;

    if (!authKey) return false;
    return this.$helper.isAuthorized(authKey)
  }
  onAddressSelect(item: AdresEntity) {
    if (item && item.id) {
      this.selectedAddressId = item.id.toString();
      localStorage.setItem("selectedAddressItemId", item.id.toString());
      this.$emit('address-selected', item);
    }
  }

  @Watch('selectedAddressId')
  onSelectedAddressIdChange(newVal: string | null) {
    if (newVal) {
      const selectedAddress = this.localValue.find((address:any) => address.id === newVal);
      if (selectedAddress) {
        this.$emit('address-selected', selectedAddress);
      }
    }
  }
}
